<template>
    <div class="input-text" style="width: 100%;">
        <InputText
            type="text"
            style="width: 100%"
            :name="`${step.name}[${data.element_details.name}]`"
            v-model="field.value"
        />
    </div>
</template>

<script setup>
defineProps({
    data: Object,
    field: Object,
    step: Object,
})

defineEmits(['update:modelValue'])
</script>